module.exports = __webpack_public_path__ + "img/guanjian22.d0009c5a.webp";